<template>
  <div>
    <section class="display-flex">
      <div style="margin-right: 10px;">
        <label class="desc-label">寻房指引</label>
        <p style="font-size: 12px;color: red">请选中列表模式编辑</p>
      </div>
      <tinymce style="width: 600px" :plugins="['lists']" toolbar1="numlist bullist outdent indent" ref="guideEditor" id="guideEditor"></tinymce>
    </section>
    <section class="display-flex">
      <div style="margin-right: 10px;">
        <label class="desc-label">特别提醒</label>
        <p style="font-size: 12px;color: red">请选中列表模式编辑</p>
      </div>
      <tinymce style="width: 600px" :plugins="['lists']" toolbar1="numlist bullist outdent indent" ref="remindEditor" id="remindEditor"></tinymce>
    </section>
    <section class="display-flex">
      <div style="margin-right: 10px;">
        <label class="desc-label">入住须知</label>
        <p style="font-size: 12px;color: red">请选中列表模式编辑</p>
      </div>
      <tinymce style="width: 600px" :plugins="['lists']" toolbar1="numlist bullist outdent indent" ref="noteEditor" id="noteEditor"></tinymce>
    </section>
    <section class="display-flex">
      <div style="margin-right: 10px;">
        <label class="desc-label">房间特色</label>
        <p style="font-size: 12px;color: red">请选中列表模式编辑</p>
      </div>
      <tinymce style="width: 600px" :plugins="['lists']" toolbar1="numlist bullist outdent indent" ref="featureEditor" id="featureEditor"></tinymce>
    </section>
  </div>
</template>

<script>
export default {
  
}
</script>

<style lang="scss" scoped>
.display-flex {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 20px;
}
.desc-label{
  display: block;
  margin-top: 10px;
  text-align: end;
}
</style>



// WEBPACK FOOTER //
// src/pages/room/room-detail/description.vue